import { resolveDisplayName } from './translateDisplayName';

// Pastel backgrounds paired with dark text, hashed per name so the same person
// keeps the same color everywhere (sidebar, popover, replies, in-page pins).
// Plain hex values rather than Tailwind classes: the in-page pin markers live in
// the site iframe, which has no access to this app's stylesheet.
export const AVATAR_COLORS = [
  '#C4E1FF',
  '#FFC2FE',
  '#D7F391',
  '#BCD7C3',
  '#CFFAFE',
  '#FED7AA',
  '#D6D1FC',
  '#F6E58D',
];

export const AVATAR_TEXT_COLOR = '#737373';

// Resolved comments drop the per-person color and go grey.
export const RESOLVED_AVATAR_COLOR = '#F7F7F7';

export function getAvatarColor(name?: string | null): string {
  const avatarName = resolveDisplayName(name);
  let hash = 0;
  for (let i = 0; i < avatarName.length; i++) {
    hash = (hash * 31 + avatarName.charCodeAt(i)) >>> 0;
  }
  return AVATAR_COLORS[hash % AVATAR_COLORS.length];
}

export function getAvatarInitial(name?: string | null): string {
  return resolveDisplayName(name).charAt(0).toUpperCase();
}
